/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  ICianApiMobileSiteV1RegionMetaRequest,
  TCianApiMobileSiteV1RegionMetaModel,
  IMappers,
  TCianApiMobileSiteV1RegionMetaResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IRegionMetaResponseSchema198 } from '../../../../entities/schemas/RegionMetaResponseSchema198';
import type { IRegionMetaErrorResponseSchema199 } from '../../../../entities/schemas/RegionMetaErrorResponseSchema199';

export function createCianApiMobileSiteV1RegionMetaModel(
  parameters: ICianApiMobileSiteV1RegionMetaRequest,
): TCianApiMobileSiteV1RegionMetaModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/mobile-site/v1/region_meta/',
    response: {
      200: {
        contentType: 'json',
      },
      500: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ICianApiMobileSiteV1RegionMetaOptions<TResponse200, TResponse500> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse500>;
  parameters: ICianApiMobileSiteV1RegionMetaRequest;
}

export async function fetchCianApiMobileSiteV1RegionMeta<TResponse200, TResponse500>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiMobileSiteV1RegionMetaOptions<TResponse200, TResponse500>): Promise<
  FetchResponse<TCianApiMobileSiteV1RegionMetaResponse> | TResponse200 | TResponse500
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiMobileSiteV1RegionMetaModel(parameters),
    config,
  )) as FetchResponse<TCianApiMobileSiteV1RegionMetaResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IRegionMetaResponseSchema198, headers);
    }
    if (statusCode === 500) {
      return mappers[500](response as IRegionMetaErrorResponseSchema199, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiMobileSiteV1RegionMetaResponse>;
}
